import React from 'react';
import { Box, Palette, Typography } from '@mui/material';

export const DotValue: React.FC<{
  color: (palette: Palette) => string;
  children: React.ReactNode;
}> = ({ color, children }) => (
  <Box display="inline-flex" alignItems="baseline" gap={0.75}>
    <Box
      sx={(theme) => ({
        width: '0.5rem',
        height: '0.5rem',
        flexShrink: 0,
        alignSelf: 'center',
        borderRadius: '50%',
        backgroundColor: color(theme.palette),
      })}
    />
    <Typography variant="body1" color="text.primary" noWrap>
      {children}
    </Typography>
  </Box>
);
